module.exports = __webpack_public_path__ + "static/media/dorp.5feb9f09.jpg";